/* globals: wc_bookings_admin_calendar_js_params */

/**
 * External dependencies
 */
import { render } from '@wordpress/element';
import { forEach } from 'lodash';

/**
 * Internal dependencies.
 */
import DatePickerPopoverMonth from './components/datepicker-popover-month';
import DatePickerPopoverDay from './components/datepicker-popover-day';
import CalendarPopover from './components/calendar-popover';

const { default_month, default_year, default_day } = wc_bookings_admin_calendar_js_params;

const getAnchorRect = popoverElement => popoverAnchorElement => {
	// set anchor tag if missing.
	if( ! popoverAnchorElement || 'A' !== popoverAnchorElement.tagName  ){
		popoverAnchorElement =  popoverElement.querySelector('.wc-bookings-event-link');
	}

	const td = popoverElement.closest( 'td' );
	const tableRect = popoverElement.closest( 'table' ).getBoundingClientRect();
	const content = popoverElement.querySelector( '.components-popover__content' ) || popoverElement;
	const anchorRect = popoverAnchorElement.getBoundingClientRect();
	const anchorPoint = {
		x: anchorRect.x + td.clientWidth / 2,
		y: anchorRect.y,
	};

	let x = anchorPoint.x;
	if ( anchorPoint.x + content.clientWidth > tableRect.width + tableRect.x ) {
		x = anchorPoint.x - content.clientWidth;
	}

	let y = anchorPoint.y;

	if ( anchorPoint.y + content.clientHeight > document.body.clientHeight ) {
		y = document.body.clientHeight - content.clientHeight;
	}

	return new DOMRect( x, y, 0, 0 );
};

const popoverContainerMonth = document.getElementById( 'wc-bookings-datepicker-container-month' );

if ( null !== popoverContainerMonth ) {
	const pickerMonth = <DatePickerPopoverMonth year={ default_year } month={ default_month } />;
	render( pickerMonth, popoverContainerMonth );
}

const popoverContainerDay = document.getElementById( 'wc-bookings-datepicker-container-day' );

if ( null !== popoverContainerDay ) {
	const pickerDay = <DatePickerPopoverDay year={ default_year } month={ default_month } day={ default_day } />;
	render( pickerDay, popoverContainerDay );
}

const calendarEventMonth = document.getElementsByClassName( 'calendar_month_event' );

if ( null !== calendarEventMonth ) {
	forEach( calendarEventMonth, function( value ) {
		render( <CalendarPopover getAnchorRect={ getAnchorRect( value ) } element={ value } position={ 'bottom center' } />, value );
	} );
}

const calendarEventDay = document.getElementsByClassName( 'daily_view_booking' );

if ( null !== calendarEventDay ) {
	forEach( calendarEventDay, function( value ) {
		render( <CalendarPopover element={ value } position={ 'bottom center' } />, value.childNodes[0] );
	} );
}
